export default {
  addBenefit() {
    this.consultationBenefits.push("");
  },
  removeBenefit(idx) {
    this.consultationBenefits.splice(idx, 1);
  },
};
